import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const DISMISSED_KEY = 'mela_app_banner_dismissed';
const IOS_APP_URL = 'https://apps.apple.com/us/app/mela-exhibition-marketplace/id6766425203';
const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.mela.marketplace';

function getPlatform(): 'ios' | 'android' | 'other' {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'other';
}

export default function MelaAppBanner() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const platform = getPlatform();

  useEffect(() => {
    const dismissed = sessionStorage.getItem(DISMISSED_KEY);
    const isMelaPage = location.pathname.startsWith('/mela');
    const isAuthPage = location.pathname === '/mela/auth' || location.pathname === '/mela';
    setVisible(isMelaPage && !isAuthPage && !dismissed);
  }, [location.pathname]);

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, '1');
    setVisible(false);
  };

  const storeUrl = platform === 'ios' ? IOS_APP_URL : ANDROID_APP_URL;
  const storeLabel = platform === 'ios' ? 'App Store' : platform === 'android' ? 'Play Store' : null;

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1A1510',
      borderBottom: '1px solid rgba(232,136,26,.2)',
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '10px 16px',
      fontFamily: 'inherit',
    }}>
      {/* App icon */}
      <div style={{
        width: 36, height: 36, borderRadius: 8, flexShrink: 0,
        background: 'linear-gradient(135deg, #E8881A, #C8621A)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18,
      }}>
        🪔
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#F5EDD8', lineHeight: 1.2 }}>Mela</div>
        <div style={{ fontSize: 11, color: '#8A7260', marginTop: 1 }}>
          {platform === 'other'
            ? 'Better on mobile — scan QR, discover exhibitions'
            : 'Get the full app — scan QR, save brands, earn points'}
        </div>
      </div>

      {/* CTA */}
      {storeLabel ? (
        <a
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            flexShrink: 0,
            background: '#E8881A', color: '#fff',
            fontSize: 12, fontWeight: 700,
            padding: '7px 14px', borderRadius: 20,
            textDecoration: 'none', whiteSpace: 'nowrap',
          }}
        >
          Get on {storeLabel}
        </a>
      ) : (
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          <a href={IOS_APP_URL} target="_blank" rel="noopener noreferrer" style={{
            background: '#E8881A', color: '#fff',
            fontSize: 11, fontWeight: 700, padding: '6px 12px', borderRadius: 20,
            textDecoration: 'none', whiteSpace: 'nowrap',
          }}>
            iOS
          </a>
          <a href={ANDROID_APP_URL} target="_blank" rel="noopener noreferrer" style={{
            background: 'rgba(232,136,26,.15)', color: '#E8881A',
            fontSize: 11, fontWeight: 700, padding: '6px 12px', borderRadius: 20,
            textDecoration: 'none', whiteSpace: 'nowrap',
            border: '1px solid rgba(232,136,26,.3)',
          }}>
            Android
          </a>
        </div>
      )}

      {/* Dismiss */}
      <button
        onClick={handleDismiss}
        style={{
          flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer',
          color: '#8A7260', fontSize: 18, lineHeight: 1, padding: '0 4px',
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
